export default {"src":"/_next/static/media/process-tracking-inactive.29ddd14b.svg","height":3,"width":207,"blurWidth":0,"blurHeight":0};